<template>
    <div class="mb-2" :class="{ 'card': open, 'card-body': open }">
        <div class="form-row">
            <div class="col-auto d-flex align-items-center">
                <i class="fas fa-bars text-secondary handle" style="cursor: grab"></i>
            </div>
            <div class="col-auto">
                <input class="form-control" type="text" v-model="value.key"
                       @input="$emit('input', value)"
                       placeholder="Chiave"/>
            </div>
            <div class="col-auto">
                <input class="form-control" type="text" v-model="value.title"
                       @input="$emit('input', value)"
                       placeholder="Titolo"/>
            </div>

            <div class="col-auto">
                <b-form-select :options="fieldTypes" v-model="value.type" @input="$emit('input', value)"></b-form-select>
            </div>
            <div class="col-auto">
                <button @click.prevent="$emit('open')" class="btn btn-primary">Configura</button>
            </div>
            <div class="col row justify-content-end">
                <div class="col-auto">
                    <button @click.prevent="$emit('delete')" class="btn btn-danger"><i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </div>

        <hr v-if="open" class="mt-3"/>
        <div v-if="open" class="row">
            <div class="col-12">
                <div class="form-group" v-if="['select', 'radio'].includes(value.type)">
                    <b-form-tags
                        add-button-text="Aggiungi"
                        placeholder="Aggiungi opzione"
                        v-model="value.options"
                        @input="$emit('input', value)"
                    ></b-form-tags>
                </div>
                <div v-if="value.type === 'yesno'" class="row">
                    <div class="form-group">
                        <label for="yes-text">Testo Si</label>
                        <input id="yes-text" class="form-control" type="text"
                               v-model="value.yes"
                               @input="$emit('input', value)"
                               placeholder="Si"/>
                    </div>
                </div>
                <div v-if="value.type === 'yesno'" class="row">
                    <div class="form-group">
                        <label for="no-text">Testo No</label>
                        <input id="no-text" class="form-control" type="text"
                               v-model="value.no"
                               @input="$emit('input', value)"
                               placeholder="No"/>
                    </div>
                </div>
                <div v-if="value.type === 'yesno'" class="row">
                    <div class="form-group">
                        <label for="yesno-title">Titolo Si/No</label>
                        <input id="yesno-title" class="form-control" type="text"
                               v-model="value.yesnoTitle"
                               @input="$emit('input', value)"
                               placeholder="Titolo Si/No"/>
                    </div>
                </div>
                <div v-if="value.type === 'checkbox'" class="form-group">
                    <label for="checkbox-text">Testo Checkbox</label>
                    <input id="checkbox-text" class="form-control" type="text"
                           v-model="value.checkboxText"
                           @input="$emit('input', value)"
                           placeholder="Testo Checkbox"/>
                </div>
                <b-form-group
                    v-if="value.type === 'section'"
                    label="Codice della sezione"
                    label-for="section-code">
                    <ace-editor style="height: 250px" v-model="value.sectionCode" @input="$emit('input', value)" @init="htmlEditorInit" lang="html"></ace-editor>
                </b-form-group>
                <div class="form-group" v-if="['string', 'date', 'checkbox'].includes(value.type)">
                    <b-form-checkbox v-model="value.required">
                        Richiesto
                    </b-form-checkbox>
                </div>
                <div class="form-group" v-if="value.type === 'select'">
                    <b-form-checkbox v-model="value.multiple" @input="$emit('input', value)">
                        Multi selezione
                    </b-form-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DynamicField",
    props: {
        open: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: Object
    },
    data() {
        return {
            fieldTypes: [
                { value: null, text: 'Seleziona un tipo' },
                { value: 'string', text: 'Stringa' },
                { value: 'date', text: 'Data' },
                { value: 'select', text: "Selezione" },
                { value: 'checkbox', text: 'Checkbox' },
                { value: 'yesno', text: 'Si/No' },
                { value: 'section', text: 'Sezione' },
                { value: 'codes', text: 'Codici' },
                { value: 'radio', text: 'Radio' },
            ],
        }
    },
    methods: {
        htmlEditorInit(editor) {
            require('ace-builds/src-min-noconflict/ext-language_tools')
            require('ace-builds/src-min-noconflict/mode-html')
            require('ace-builds/src-min-noconflict/theme-ambiance')
            editor.session.setMode("ace/mode/html")
            editor.setOptions({
                enableBasicAutocompletion: true,
                enableSnippets: true,
                enableLiveAutocompletion: true
            });
        }
    }
}
</script>

<style scoped>

</style>
